import React from 'react';
import AIInterviewCoach from './AIInterviewCoach';
import AssistantLogo from './AssistantLogo';
import { useInterview } from './useInterviewContext';
import './AssistantPage.css';
import AIBinaryBackground from './AIBinaryBackground';
import AINeuralEngine from './AINeuralEngine';

const AssistantPage = () => {
    const { toggleCoach } = useInterview();

    const [impactCount, setImpactCount] = React.useState(0);
    const [yearsCount, setYearsCount] = React.useState(0);

    React.useEffect(() => {
        let impactTimer = setInterval(() => {
            setImpactCount(prev => {
                if (prev >= 21) {
                    clearInterval(impactTimer);
                    return 21;
                }
                return prev + 1;
            });
        }, 50);

        let yearsTimer = setInterval(() => {
            setYearsCount(prev => {
                if (prev >= 20) {
                    clearInterval(yearsTimer);
                    return 20;
                }
                return prev + 1;
            });
        }, 60);

        return () => {
            clearInterval(impactTimer);
            clearInterval(yearsTimer);
        };
    }, []);

    return (
        <div className="assistant-page-container">
            <div className="assistant-page-sidebar">
                <AIBinaryBackground />
                <AINeuralEngine />
                <div className="sidebar-header">
                    <AssistantLogo size="large" />
                    <h1>Saara | सार</h1>
                    <p className="subtitle">The essence of Guru's journey, distilled into an intelligent guide.</p>
                </div>

                <div className="sidebar-stats">
                    <div className="stat-item">
                        <span className="stat-value">{impactCount}</span>
                        <span className="stat-label">Impact Stories</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-value">{yearsCount}+</span>
                        <span className="stat-label">Years Exp</span>
                    </div>
                </div>

                <div className="sidebar-footer">
                    <button className="sidebar-settings-btn" onClick={() => toggleCoach(true)}>
                        <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="3" />
                            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1V15a2 2 0 0 1-2-2 2 2 0 0 1 2-2v-.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2v.09a1.65 1.65 0 0 0-1.51 1z" />
                        </svg>
                        Voice & Settings
                    </button>
                    <a href="/" className="back-home-link">
                        <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="19" y1="12" x2="5" y2="12" />
                            <polyline points="12 19 5 12 12 5" />
                        </svg>
                        Back to Portfolio
                    </a>
                </div>
            </div>

            <main className="assistant-main-content">
                <header className="mobile-assistant-header">
                    <AssistantLogo size="small" />
                    <h2>Saara | सार</h2>
                    <div className="mobile-header-actions">
                        <button className="mobile-settings-btn" onClick={() => toggleCoach(true)}>
                            <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="3" />
                                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1V15a2 2 0 0 1-2-2 2 2 0 0 1 2-2v-.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2v.09a1.65 1.65 0 0 0-1.51 1z" />
                            </svg>
                        </button>
                        <a href="/" className="back-link">Portfolio</a>
                    </div>
                </header>
                <AIInterviewCoach mode="salesman" />
            </main>
        </div>
    );
};

export default AssistantPage;
